import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const CancellationPolicy = () => {
  const location = useLocation();

  useEffect(() => {
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-100 px-4 py-6">
      <div className="max-w-3xl mx-auto p-6 bg-white rounded-xl shadow-md">
        
        <h2 className="text-2xl font-semibold mb-5 text-center">
          Cancellation Policy
        </h2>

        {/* Cancellation Policy */}
        <ul className="list-disc ml-5 space-y-3 text-gray-700 mb-6">
          <li>
            <strong>Order Cancellation:</strong> Orders can be cancelled within
            24 hours of placement, subject to approval from the invoice provider
            (APM ECOM MART Private Limited / Vendor). For assistance, contact us at{" "}
            <a
              href="mailto:support@apmsmarthub.com"
              className="text-blue-600 hover:underline"
            >
              support@apmsmarthub.com
            </a>{" "}
            or{" "}
            <a
              href="tel:+919481699771"
              className="text-blue-600 hover:underline"
            >
              +91 94816 99771
            </a>.
          </li>

          <li>
            <strong>Pre-Shipment Cancellation:</strong> If the order has not yet
            been shipped, the full amount will be refunded after deducting any
            reward points already provided.
          </li>

          <li>
            <strong>Post-Shipment Cancellation:</strong> Cancellation is not
            possible once the order is shipped. Customers may return the product
            for refund or exchange as per outlet policy.
          </li>
        </ul>

        {/* Refund Process */}
        <h3 className="text-xl font-semibold mb-3">Refund Process</h3>

        <ul className="list-disc ml-5 space-y-3 text-gray-700">
          <li>
            Refunds will be credited to the original payment method within
            7–10 business days after approval.
          </li>
          <li>
            Return shipping charges, if applicable, will be borne by the
            customer unless otherwise specified.
          </li>
        </ul>

      </div>
    </div>
  );
};

export default CancellationPolicy;
